import { Inject, Injectable } from '@angular/core';
import { APP_CONFIG, EnvironmentModel } from '@fh-client-interaction-frontends/fh-app-config';
import { HttpClient, HttpParams } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { CpReceiptsRequestModel } from '../../helpers/objects/request/receipts/cp-receipts-request-model';
import { CpReceiptsResponseModel } from '../../helpers/objects/response/receipts/cp-receipts-response-model';
import { CpReceiptDetailModel } from '../../helpers/objects/dto/receipt/receipt-detail/cp-receipt-detail-model';

@Injectable({
  providedIn: 'root'
})
export class CpReceiptsService {
  appConfig: EnvironmentModel = new EnvironmentModel();

  constructor(@Inject(APP_CONFIG) protected appConfigTemp: EnvironmentModel, private http: HttpClient) {
    this.appConfig = appConfigTemp;
  }

  getAll(token: string, request: CpReceiptsRequestModel): Observable<CpReceiptsResponseModel> {
    const params = new HttpParams({
      fromObject: request as any
    });
    return this.http
      .get<any>(this.appConfig.api + 'contracts/' + encodeURIComponent(token) + '/receipts', { params })
      .pipe(map((response) => response.body as CpReceiptsResponseModel));
  }

  getDetails(token: string, receiptId: string): Observable<CpReceiptDetailModel> {
    return this.http
      .get<any>(this.appConfig.api + 'contracts/' + encodeURIComponent(token) + '/receipts/' + encodeURIComponent(receiptId))
      .pipe(map((response) => response.body as CpReceiptDetailModel));
  }
}
